import { Skeleton } from '../ui/skeleton';
import { Button } from '../ui/button';
import { UserPlus } from 'lucide-react';

/**
 * Loading skeleton + the two empty states for SearchPage.
 *
 *   • `loading` → six skeleton tiles
 *   • `hasNoContactsAtAll` → "No contacts yet. Add some!" with a CTA
 *     button (parent supplies `onAdd`).
 *   • Otherwise → "No contacts found" (after filters).
 */
export default function SearchEmptyState({
  loading,
  hasNoContactsAtAll,
  onAdd,
}) {
  if (loading) {
    return (
      <div className="grid grid-cols-3 gap-4">
        {[1, 2, 3, 4, 5, 6].map((i) => (
          <Skeleton key={i} className="h-28 rounded-xl" />
        ))}
      </div>
    );
  }

  return (
    <div className="text-center py-16">
      <p className="text-muted-foreground text-sm">
        {hasNoContactsAtAll ? 'No contacts yet. Add some!' : 'No contacts found'}
      </p>
      {hasNoContactsAtAll && (
        <Button
          onClick={onAdd}
          className="mt-4 bg-nav-blue hover:bg-nav-blue/90 text-white rounded-full"
        >
          <UserPlus size={16} className="mr-2" />
          Add Your First Contact
        </Button>
      )}
    </div>
  );
}
